__turbopack_context__.v({
  "blurred": "ButtonLink-module__skFnBa__blurred",
  "notScrolled": "ButtonLink-module__skFnBa__notScrolled",
  "root": "ButtonLink-module__skFnBa__root" + " " + __turbopack_context__.i(931616)["ctaStyle"],
  "sizeM": "ButtonLink-module__skFnBa__sizeM",
});
